module.exports = __webpack_public_path__ + "media/flags/ga-44cfa6ef.svg";